import React from 'react';

// Section 7.1 status pills.
const STYLES = {
  accepted: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300',
  pending: 'bg-amber-50 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300',
  declined: 'bg-red-50 text-red-700 dark:bg-red-500/15 dark:text-red-300',
  draft: 'bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-slate-400',
  published: 'bg-teal-50 text-teal-700 dark:bg-teal-500/15 dark:text-teal-300',
  cancelled: 'bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-slate-400',
};

const LABELS = {
  accepted: 'Accepted',
  pending: 'Pending',
  declined: 'Declined',
  draft: 'Draft',
  published: 'Published',
  cancelled: 'Cancelled',
};

export default function StatusPill({ status, label, className = '', ...rest }) {
  const style = STYLES[status] || STYLES.draft;
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap ${style} ${className}`} {...rest}>
      {label || LABELS[status] || status}
    </span>
  );
}
